export const LOADER_STATUS = 'boilderplate/GSTR6COMMON/LOADER_STATUS';
export const PROFILE_INFO = 'boilerplate/GSTR6COMMON/PROFILE_INFO';
export const VENDOR_LIST = 'boilerplate/GSTR6COMMON/VENDOR_LIST';
export const STORE_ENTITY = 'boilerplate/GSTR6COMMON/STORE_ENTITY';
export const SET_FILING_STATUS = 'boilerplate/GSTR6COMMON/SET_FILING_STATUS';
export const STORE_GSTIN = 'boilerplate/GSTR6COMMON/STORE_GSTIN';
export const STORE_PERIOD = 'boilerplate/GSTR6COMMON/STORE_PERIOD';
export const STORE_DROPDOWN_GSTIN = 'boilerplate/GSTR6COMMON/STORE_DROPDOWN_GSTIN';